import { Router, RouterLink } from '@angular/router';
import { Component, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionTableBaseComponentDirective } from '../../shared/selection-table/selection-table-base-component.directive';
import { Pending } from '../pending.model';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCheckbox } from '@angular/material/checkbox';
import { TABLE_BASE_COMMON_IMPORTS } from '../../material-base-common-imports';


@Component({
  // tslint:disable:component-selector
  selector: 'eca-bio-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  imports: [MatSort, MatCheckbox, MatSortHeader, RouterLink, ...TABLE_BASE_COMMON_IMPORTS]
})
export class BiographicTableComponent extends SelectionTableBaseComponentDirective<Pending> {
  private router = inject(Router);


  @ViewChild(MatSort, {static: true}) sort: MatSort;

  @Input() sessionId: string;

  @Input() set biographics(biographics: Pending[]) {
    if (!biographics) {
      return;
    }
    this.dataSource = new MatTableDataSource(biographics);
    if (!this.sort.direction) {
      this.sort.direction = 'asc';
    }
    if (!this.sort.active) {
      this.sort.active = 'lithocode';
    }
    this.dataSource.sort = this.sort;
  }

  @Output() rejectDocument = new EventEmitter<string>();

  displayedColumns = [
    'select',
    'lithocode',
    'form',
    'stateStudentId',
    'lastName',
    'firstName',
    'birthDate',
    'gender',
  ];

  /* istanbul ignore next */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.data
        .filter(pending => pending.canSubmit())
        .forEach(row => this.selection.select(row));
    }

    this.selected.emit(this.selection.selected);
  }

}

